import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KbRoutingModule } from './kb-routing.module';
import { KbComponent } from './kb.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { KbTemplateComponent } from './kbtemplate.component';
import { ClipboardModule } from 'ngx-clipboard';
import { RouterModule } from '@angular/router';
import { NgProgressModule } from 'ngx-progressbar';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { SanitizeHtmlPipe } from '../shared/sanitize-html.pipe';

@NgModule({
  imports: [
    CommonModule, 
    NgbModule, 
    RouterModule,
    SharedModule,
    NgProgressModule,
    ChildHeaderModule
  ],
  declarations: [    
    KbTemplateComponent
  ],
  exports: [
    KbTemplateComponent
  ]
})

export class KbTemplateModule {}